import { Component, OnInit ,Output, EventEmitter, Input,ViewChild,ElementRef} from '@angular/core';
import { FormGroup } from '@angular/forms';
import * as moment from 'moment';


@Component({
  selector: 'app-date-range-picker',
  templateUrl: './date-range-picker.component.html',
  styleUrls: ['./date-range-picker.component.scss']
})
export class DateRangePickerComponent implements OnInit {
  @ViewChild('dropdownDiv') dropdownDiv: ElementRef<HTMLElement>;
  

  @Output() getDateRangePickerData = new EventEmitter();

  @Input() datepickerCallFromDashboard = false;
  @Input() datepickerDefaultValue={
    'labelValue':'last30days',
    'fromDate':'',
    'toDate':'',
  };
  
  
  bsInlineValue = new Date();
  pmdInlineValue = new Date();
  // bsInlineRangeValue: Date[];
  maxDate = new Date();
  locale = 'en-gb';
  isCustomRangeOpen = false;
  isComparisonOpen = false;
  autoCloseValue = true;
  myForm: FormGroup;
  seletedToDate;
  seletedFromDate;
  labelForRange;
  duration: Date[] = [];
  dateDetail_obj = {
    seletedToDate: null,
    seletedFromDate: null,
    labelForRange: null,
    lastLabelForRange: null,
    selectedLabelValue: null,
    lastSelectedLabelValue: null,
  }
  labelForCustomRange = null
  activeClassStatus: boolean = false
  bsMaxDate= new Date();
  
  constructor() { 
  }

  ngOnInit(): void {
    this.getDropDownValue(this.datepickerDefaultValue.labelValue); 
    if(this.datepickerDefaultValue.labelValue=='custom'){
      this.dateDetail_obj.seletedFromDate=this.datepickerDefaultValue.fromDate;
      this.dateDetail_obj.seletedToDate=this.datepickerDefaultValue.toDate;
    } 
    this.getDateRangePickerData.emit(this.dateDetail_obj);
  }

  cancelDatePicker() {
    this.dateDetail_obj.labelForRange = this.dateDetail_obj.lastLabelForRange;
    this.dateDetail_obj.selectedLabelValue = this.dateDetail_obj.lastSelectedLabelValue;
  }

  onShownDuration() {
    this.isCustomRangeOpen = false;
    this.isComparisonOpen = false;
  }  

  openCustomRangePicker() {
      this.isCustomRangeOpen = true
      this.isComparisonOpen = false
  }
  doNoteCloseDropDown() {
    // this.isCustomRangeOpen = true
  }

  /***
   * Get Date Data From DropDown Menu
   */
  getDropDownValue(value) {
    this.dateDetail_obj.lastLabelForRange = this.dateDetail_obj.labelForRange;
    this.dateDetail_obj.lastSelectedLabelValue = this.dateDetail_obj.selectedLabelValue;
    if(value == 'today') {
      this.dateDetail_obj.seletedToDate = moment(new Date()).format('YYYY-MM-DD');
      this.dateDetail_obj.seletedFromDate = moment(new Date()).format('YYYY-MM-DD');
      this.dateDetail_obj.labelForRange = 'Today'
      this.dateDetail_obj.selectedLabelValue = 'today'
    } else if(value == 'yesterday') {
      this.dateDetail_obj.seletedToDate = moment(moment(new Date()).subtract(1, 'day')).format('YYYY-MM-DD');
      this.dateDetail_obj.seletedFromDate = moment(moment(new Date()).subtract(1, 'day')).format('YYYY-MM-DD');
      this.dateDetail_obj.labelForRange = 'Yesterday'
      this.dateDetail_obj.selectedLabelValue = 'yesterday'
    } else if(value == 'thisweek') {
      this.dateDetail_obj.seletedFromDate = moment(moment().startOf('isoWeek')).format('YYYY-MM-DD');
      this.dateDetail_obj.seletedToDate = moment(new Date()).format('YYYY-MM-DD');
      this.dateDetail_obj.labelForRange = 'This Week'
      this.dateDetail_obj.selectedLabelValue = 'thisweek'
    } else if(value == 'lastweek') {
      this.dateDetail_obj.seletedFromDate = moment().subtract(1, 'weeks').startOf('isoWeek').format('YYYY-MM-DD')
      this.dateDetail_obj.seletedToDate = moment().subtract(1, 'weeks').endOf('isoWeek').format('YYYY-MM-DD')
      this.dateDetail_obj.labelForRange = 'Last Week'
      this.dateDetail_obj.selectedLabelValue = 'lastweek'
    } else if(value == 'last15days') {
      this.dateDetail_obj.seletedFromDate = moment(moment(new Date()).subtract(14, 'day')).format('YYYY-MM-DD');
      this.dateDetail_obj.seletedToDate = moment(new Date()).format('YYYY-MM-DD');
      this.dateDetail_obj.labelForRange = 'Last 15 Days'
      this.dateDetail_obj.selectedLabelValue = 'last15days'
    } else if(value == 'last30days') {
      this.dateDetail_obj.seletedFromDate = moment(moment(new Date()).subtract(29, 'day')).format('YYYY-MM-DD');
      this.dateDetail_obj.seletedToDate = moment(new Date()).format('YYYY-MM-DD');
      this.dateDetail_obj.labelForRange = 'Last 30 Days'
      this.dateDetail_obj.selectedLabelValue = 'last30days'
    } else if(value == 'lastquarter') {
      this.dateDetail_obj.seletedFromDate = moment(moment(new Date()).subtract(89, 'day')).format('YYYY-MM-DD');
      this.dateDetail_obj.seletedToDate = moment(new Date()).format('YYYY-MM-DD');
      this.dateDetail_obj.labelForRange = 'Last 90 Days'
      this.dateDetail_obj.selectedLabelValue = 'lastquarter'
    } else if(value == 'custom') {
      this.dateDetail_obj.labelForRange = 'Custom Range'
      this.dateDetail_obj.selectedLabelValue = 'custom'
    } else if(value == 'none') {
      this.dateDetail_obj.seletedFromDate = ''
      this.dateDetail_obj.seletedToDate = ''
      this.dateDetail_obj.labelForRange = null
      this.dateDetail_obj.selectedLabelValue = 'none'
    }

    if (value != 'custom') {
      this.getDateRangePickerData.emit(this.dateDetail_obj);
    }
  }

  durationChange(duration: Date[]) {
    this.duration = duration;
  }

  applyCustomDate() {
    this.dateDetail_obj.seletedFromDate = moment(this.duration[0]).format('YYYY-MM-DD');
    this.dateDetail_obj.seletedToDate = moment(this.duration[1]).format('YYYY-MM-DD');
    this.dateDetail_obj.labelForRange = 'Custom Range'
    this.getDateRangePickerData.emit(this.dateDetail_obj);
  }

  /**
   * Reset date range picker value
   */
  resetDateRangepickerValue(){
    this.getDropDownValue('last30days');
  }

  /**
   * open date range picker dropdown values 
   */
  datePickerClickFromDashboard(){
    let el: HTMLElement = this.dropdownDiv.nativeElement;
    el.click();
  }
}
